/**
 * Print Drug Label page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, PipeTransform, Pipe, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, NavParams, Platform } from '@ionic/angular';
// import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';

/**
 * Services
 */
import { PouchService } from '../services/pouch-service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'page-print-drug-label',
  templateUrl: 'print-drug-label.html',
  styleUrls: ['print-drug-label.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PrintDrugLabelPage {
  navParams = {};
  public entity;
  /* options: PrintOptions = {
    name: 'MyDocument',
    //printerId: 'printer007',
    duplex: true,
    orientation: 'landscape',
    //grayscale: true
  }; */
  doctor: '';

  constructor(public navParams2: NavParams, private titleService: Title, private platform: Platform, public db: PouchService, private router: Router, public navCtrl: NavController) {
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : this.navParams2.data;
    this.entity = this.navParams['entity'];
    this.titleService.setTitle(`Print Drug Label- ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
    if (this.entity.user != undefined && this.entity.user != '') {
      this.db.get(this.entity.user, 'user').then((user) => {
        this.doctor = user.fullname;
      });
    }
  }

  ionViewDidEnter() {
    this.db.print();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }

  back() {
    this.navCtrl.pop();
  }
}
